<template>
  <div class="empty-section">
    <div class="flex flex-col items-center">
      <img :src="$publicUrl('images/img_medium_search.webp')" alt="img_medium_search" class="mr-8" loading="lazy" width="128" />
      <BlTextAv variation="subheading-18" weight="bold" class="mt-24">Belum ada transaksi</BlTextAv>
      <BlTextAv variation="body-14" class="mt-8 text-center">
        Riwayat transaksi pembelian kelas nantinya bisa kamu cek di halaman ini.
      </BlTextAv>
    </div>
  </div>
</template>

<script>
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'EmptyTransaction',
  components: {
    BlTextAv,
  },
};
</script>

<style lang="scss" scoped>
.empty-section {
  margin-top: 48px;
}
</style>
